import { FieldValidation } from '../../core/domain/transaction/fieldValidation';

export const pattern = (regex: RegExp): FieldValidation => {
	return (value) => {
		return !value || regex.test(value);
	};
};
